module.exports = __webpack_public_path__ + "img/0S6A0073.1d613890.jpg";